import React from 'react'
import CustomToolTip from '@Components/Tooltips/CustomToolTip'
import ValueBandsToolTip from '@Components/MatchComponents/ValueBandsToolTip'

interface MatchingHeaderLabelsProps {
    selectedListLength: number
}

const MatchingHeaderLabels = (props: MatchingHeaderLabelsProps) => (
    <div className="header-labels">
        <p>ISRC</p>
        <p>Recording Title</p>
        <p>Recording Artist</p>
        <p>Writer(s)</p>
        <div className="with-tooltip">
            <p>Source</p>
            <CustomToolTip
                type="?"
                info={
                    <>
                        <b>H</b> = Historical Unmatched <br />
                        These unmatched royalties were generated before January 1, 2021. <br />
                        <br />
                        <b>B</b> = Blanket License <br />
                        These unmatched royalties were generated on or after January 1, 2021.
                    </>
                }
            />
        </div>
        <div className="with-tooltip">
            <p>Estimated Value</p>
            <ValueBandsToolTip inverseColor={false} />
        </div>
        <p id="selected-count" className={`${props.selectedListLength === 0 ? 'greyed' : ''}`}>
            {props.selectedListLength} Selected
        </p>
    </div>
)

export default MatchingHeaderLabels
